import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useWindowDimensions from "./hooks/useWindowDimensions";
import "./GamesListingScreen.css";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import GameService from "./api/services/GameService";
import FetchLoader from "./components/common/Loader/FetchLoader";
import GamesCardDark from "./components/cards/GamesCardDark";
import { isMobile } from "./utils/_helper";
import { setToken, removeToken } from "./store/actions/setToken.action";
import SessionService from "./api/services/SessionService";

export default function GamesListingScreen(props) {
  const [gamesList, setGamesList] = useState([]);
  const [showLoader, setShowLoader] = useState(true);

  const dispatch = useDispatch();
  const { width } = useWindowDimensions();

  const [invalid, setInvalid] = useState(false);
  const location = useLocation();
  const aid = new URLSearchParams(location.search).get("aid");

  const tokenState = useSelector((state) => state.SetToken.token);

  useEffect(() => {
    if (aid) {
      dispatch(setToken(aid));
      SessionService.set("token", aid);
    } else dispatch(removeToken());
  }, [dispatch, aid]);

  useEffect(() => {
    if (!tokenState) {
      setShowLoader(true);
    } else {
      setShowLoader(false);
    }
  }, [tokenState]);

  setTimeout(() => {
    if (!tokenState) {
      setShowLoader(false);
      setInvalid(true);
    }
  }, 2000);

  useEffect(() => {
    if (tokenState) {
      (async () => {
        let response = await GameService.listGames("");
        if (response.success) {
          setGamesList(response.data);
          setShowLoader(false);
          dispatch({ type: "RESET_ERROR" });
        } else {
          dispatch({ type: "SET_ERROR", payload: response.data });
        }
      })();
    }
  }, [dispatch, tokenState]);

  const openpop = () => {
    dispatch({ type: "DISPLAY_FEEDBACK_POPUP", payload: true });
  };

  return (
    <>
      {!showLoader ? (
        <div className="games-container">
          <style
            dangerouslySetInnerHTML={{
              __html: `
              .navbar {
              background: #EAEAFF;
              }    
              .main-mobile-bg{
                background: none
              }
              .habits{
                height: 190px;
                column-gap: 26px;
                cursor: pointer;
              }  
              .habit-card-content{
                margin-top: 2.6rem;
              }   
              .habit-image{
                height: 48px;
                width: 70px;
              }    
              .games-wrapper{
                margin-bottom: 1rem;
              }
                @media only screen 
                and (min-width: 600px) 
                and (max-width:1024px){
                .add-habit-parent {
                  padding-left: 2rem;
                }
              }
              .habit-card-content{
                position: relative;
              }
      `,
            }}
          />

          <div
            style={{ paddingTop: "1rem", justifyItems: "center" }}
            className="games-wrapper container"
          >
            <h5
              className="games-header-text"
              style={{
                color: isMobile() && `white`,
                display: "flex",
                justifyContent: "center",
              }}
              onClick={() => openpop()}
            >
              Games
            </h5>
          </div>
          <div className="container add-habit-parent">
            {gamesList.map((card, i) => (
              <GamesCardDark
                heading={card.title}
                id={card.id}
                image={card.image}
                theme={card.theme}
                text={card.description}
                slug={card.slug}
                type={card.type}
                locked={card.locked || false}
                cardType={"games"}
                overlay={card.overlay}
                overlay_text={card.overlay_text}
                backgroundImage={card.banner}
                aid={aid}
              />
            ))}
          </div>
        </div>
      ) : (
        <FetchLoader text="Loading..." />
      )}
    </>
  );
}
